<template>
  <div class="d-flex">
    <slot></slot>
    <button class="btn btn-secondary ml-2" @click="selectAll" :disabled='isDisabled'>
      <i v-if="this.data && this.data.length === 0" class="fas fa-check"></i>
      <i v-else class="fas fa-times"></i>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'OptionsToggleMultiselect',
    props: {
      data: Array,
      options: Array,
      isDisabled: Boolean,
      toggleCb: {
        type: Function,
        default: () => {
        }
      }
    },
    methods: {
      selectAll() {
        if (this.data.length !== this.options.length) {
          this.$emit('update:data', [...this.options]);
          this.toggleCb();
        } else {
          this.$emit('update:data', []);
          this.toggleCb();
        }
      }
    }
  }
</script>

<style scoped>
  .btn {
    max-width: 30px;
    min-width: 30px;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/OptionsToggleMultiselect.vue